import { useEnableProductInventorySyncTab } from '../feature-flags/hooks/use-enable-product-inventory-sync-tab';
import { useIsSellerFeatureEnabled } from '../hooks/use-is-seller-feature-enabled';
import { SellerFeatures } from '../enums/seller-features';

export const useIsProductInventorySyncTabAvailable = (): boolean => {
  const isLdEnabled = useEnableProductInventorySyncTab();
  const isAddOnEnabled = useIsSellerFeatureEnabled(SellerFeatures.InventorySync);
  return isLdEnabled && isAddOnEnabled;
};
